// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3SN4T","signatureButtonsRight":"ModalSign_signatureButtonsRight__1nF8M"};